import { render, staticRenderFns } from "./ProductCategoryList.vue?vue&type=template&id=4643d439&scoped=true"
import script from "./ProductCategoryList.vue?vue&type=script&lang=js"
export * from "./ProductCategoryList.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryList.vue?vue&type=style&index=0&id=4643d439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643d439",
  null
  
)

export default component.exports